var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.51973 22H21.4803C23.4191 22 24.6278 19.8398 23.6583 18.1194L14.1781 1.29031C13.2086 -0.430104 10.7914 -0.430104 9.82193 1.29031L0.341656 18.1194C-0.627774 19.8398 0.580866 22 2.51973 22ZM12 12.9452C11.3076 12.9452 10.741 12.3631 10.741 11.6516V9.06453C10.741 8.35308 11.3076 7.77098 12 7.77098C12.6925 7.77098 13.259 8.35308 13.259 9.06453V11.6516C13.259 12.3631 12.6925 12.9452 12 12.9452ZM13.259 18.1194H10.741V15.5323H13.259V18.1194Z",
    fill: "#fb3333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRed);
export default __webpack_public_path__ + "static/media/warning_red.cbbb03073c3f802881a83b6b3a6652ee.svg";
export { ForwardRef as ReactComponent };